import { EditCpmPriceGroupDataValue } from './groupsEditState';

export enum CampaignsScreenUrlSearchQueryParams {
    campaignsIds = 'campaigns-ids',
    campaignType = 'campaign-type',
    ulogin = 'ulogin',
    isNew = 'is-new'
}

export enum SurveyStatus {
    DRAFT = 'DRAFT',
    MODERATION = 'MODERATION',
    MODERATION_REJECTED = 'MODERATION_REJECTED',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    UNFEASIBLE = 'UNFEASIBLE'
}

export enum BrandSurveyStopReason {
    LOW_BUDGET = 'LOW_BUDGET',
    LOW_REACH = 'LOW_REACH'
}

export interface BrandSurveyStatus {
    surveyStatus: SurveyStatus;
    reasonIds: string[];
    brandSurveyStopReasons: BrandSurveyStopReason[];
}

export interface CampaignSettings {
    value: EditCpmPriceGroupDataValue;
    regions?: string;
    startDate?: string;
    endDate?: string;
    flightOrderVolume?: number;
    behaviors?: string[];
}
